import { FormProvider } from 'contexts/formContext'
import { defaultValuesShareRecord, shareRecordValidationSchema } from './ShareRecordSchema'
import { ShareRecord } from './ShareRecord'
import { useState } from 'react';
import { PrincipalType } from 'services/permissions';
import { ShareRecordRequestType, ShareResourceDisplayType } from 'services/share/types/share';
import { AutocompleteOptionList } from 'components/Forms/Autocomplete';
import { useTenant } from 'contexts/tenantContext';
import { useOperatorList } from 'contexts/OperatorContext';
import { useGroupListData } from 'contexts/groupContext';
import { showSuccessToast, ToastType } from 'contexts/apiRequestContext';
import { useShareRecordByResourceId } from 'contexts/shareRecord';

type ShareRecordsContainerProps = {
  resourceId: string;
  resourceDisplay: ShareResourceDisplayType;
  onClose: () => void;
  setToast: React.Dispatch<React.SetStateAction<ToastType>>;
}

const defaultPageSizeAutomcomplete = { page: 0, size: 10 };

export const ShareRecordsContainer = ({ onClose, resourceId, setToast, resourceDisplay}: ShareRecordsContainerProps) => {
  const [principalType, setPrincipalType] = useState<PrincipalType | undefined>(undefined);
  const isPrincipalTypeGroup = principalType === 'Group'; 
  const isPrincipalTypeUser = principalType === 'User'; 

  const { tenantAutoCompleteProps, currentTenantId } = useTenant();
  const { operatorsAutoCompleteProps } = useOperatorList(defaultPageSizeAutomcomplete, 'always', currentTenantId, isPrincipalTypeUser);
  const { groupAutoCompleteProps } = useGroupListData(defaultPageSizeAutomcomplete, 'always', isPrincipalTypeGroup);

  const getListAutocompleteByPrincipalType = (): AutocompleteOptionList => {
    type AutocompleteOptionListMap = {
      [K in PrincipalType]?: AutocompleteOptionList;
    };

    const options: AutocompleteOptionListMap = {
      "User": operatorsAutoCompleteProps, 
      "Group": groupAutoCompleteProps, 
      "Tenant": tenantAutoCompleteProps
    }

    return options[principalType!] as AutocompleteOptionList;
  }

  const onSuccess = () => {
    showSuccessToast("Sucesso ao compartilhar registro", "", setToast); 
    onClose();
  }

  const { mutateAsync } = useShareRecordByResourceId(resourceDisplay, resourceId, onSuccess, setToast)

  const onSubmit = async (values: ShareRecordRequestType) => {
    await mutateAsync({
      permissionLevelType: values?.permissionLevelType, 
      principalId: values?.principalId,
      principalType: values?.principalType
    });
  };

  return (
    <div>
      <FormProvider
        defaultValues={defaultValuesShareRecord}
        validationSchema={shareRecordValidationSchema()}
        onSubmit={onSubmit}
        onChangeField={[
          {
            fieldName: 'principalType', delegate(fieldValue, setValue, watch) {
              setPrincipalType(fieldValue as PrincipalType);
            }
          }
        ]}
      >
        <ShareRecord
          principalAutocomplete={getListAutocompleteByPrincipalType()}
          onClose={onClose}
        />
      </FormProvider>
    </div>
  )
}
